import {useEffect, useRef, useState} from 'react';
import {fetchBackendVersion} from '../services/version-service';

const FRONT_VERSION = process.env.REACT_APP_VERSION;

// Throttle pour eviter de spammer /application/version si l'user enchaîne
// rapidement les bascules d'onglet (e.g. alt-tab rapide).
const THROTTLE_MS = 60_000;

// Detecte une MEP cote back pendant que l'user garde son onglet ouvert.
// Mecanisme : on ne poll pas, on attend le retour de focus de l'onglet
// (visibilitychange -> visible). 0 requete tant que l'onglet est cache.
// Si REACT_APP_VERSION n'est pas defini au build (e.g. build sans ARG VERSION),
// le hook reste inerte : pas de bandeau fantome.
export function useVersionCheck() {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const lastCheckRef = useRef(0);

    useEffect(() => {
        if (!FRONT_VERSION) return;

        const check = () => {
            const now = Date.now();
            if (now - lastCheckRef.current < THROTTLE_MS) return;
            lastCheckRef.current = now;

            fetchBackendVersion()
                .then(serverVersion => {
                    if (serverVersion && serverVersion !== FRONT_VERSION) {
                        setUpdateAvailable(true);
                    }
                })
                .catch(() => {
                    // silencieux : pas de bandeau en cas d'erreur reseau / backend down
                });
        };

        const onVisibility = () => {
            if (document.visibilityState === 'visible') check();
        };

        document.addEventListener('visibilitychange', onVisibility);
        return () => document.removeEventListener('visibilitychange', onVisibility);
    }, []);

    const reload = () => window.location.reload();

    return {updateAvailable, reload};
}